import confetti from 'canvas-confetti'

export const triggerConfettiFromElement = (element: HTMLElement): void => {
  if (window?.Meticulous?.isRunningAsTest) {
    return
  }
  const rect = element.getBoundingClientRect()
  const x = (rect.left + rect.width / 2) / window.innerWidth
  const y = (rect.top + rect.height / 2) / window.innerHeight

  void confetti({
    particleCount: 100,
    spread: 70,
    origin: { x, y },
    angle: 45,
  })
}
